import { type ChangeEvent, useCallback } from 'react';
import type { Lens } from '@hookform/lenses';
import { useController } from 'react-hook-form';
import { DatePickerInput, type DatePickerInputProps } from '@interxfi/design-system/components/input/date-picker-input/date-picker-input';

interface PropsWithLens extends Omit<DatePickerInputProps, 'name' | 'value'> {
  shouldUnregister?: boolean;
  lens: Lens<string>;
}

export function AppDatePickerInputWithLens({ onChange, shouldUnregister, lens, ...props }: PropsWithLens) {
  const { field, fieldState } = useController({ shouldUnregister, ...lens.interop() });
  const { onChange: fieldOnChange } = field;
  const handleChange = useCallback(
    (e: ChangeEvent<HTMLInputElement>) => {
      fieldOnChange(e.target.value);
      onChange?.(e);
    },
    [fieldOnChange, onChange],
  );

  return (
    <DatePickerInput
      {...props}
      {...field}
      error={fieldState.error?.message}
      onChange={handleChange}
      touched={fieldState.isTouched}
      value={field.value || ''}
    />
  );
}
